import { ready } from "../utils/listeners";
import Carousel from "./initialiseCarousel";

ready(() => {
  const pdpCarousel = new Carousel(".pdp-carousel-dot", ".pdp-carousel-cell");
  pdpCarousel.init();
});
